/**
 * Build the platform-specific user ID payload for API requests.
 * @param {'telegram' | 'max'} platform
 * @param {string | number} userId
 * @returns {{ tg_id: string } | { max_id: string }}
 */
export function buildUserIdPayload(platform, userId) {
    // return { tg_id: '664942774' };
    // return {tg_id: '5637524561'}


    // Сева
    // return { tg_id: '419285264' };
    // return { max_id: '180206735' };

    // if (window.location.hostname === 'localhost' || window.location.hostname.includes('devtunnels.ms')) {
        // return { tg_id: '664942774' };
    // }
    const key = platform === 'max' ? 'max_id' : 'tg_id';
    if (!hasUserId(userId)) {
        return {};
    }
    return { [key]: String(userId) };
}

export function hasUserId(userId) {
    if (userId === null || userId === undefined) return false;
    const normalized = String(userId).trim().toLowerCase();
    return !['', 'null', 'undefined', 'none'].includes(normalized);
}

/**
 * Get the platform-specific user ID key name (for FormData etc.).
 * @param {'telegram' | 'max'} platform
 * @returns {'tg_id' | 'max_id'}
 */
export function getUserIdKey(platform) {
    return platform === 'max' ? 'max_id' : 'tg_id';
}
